
import { Vue, Component, Prop, Watch, ModelSync } from "vue-property-decorator";
import Icon from "@/components/UI/Icon.vue";
import { ControlAccordion } from "@/oxygen/classes/lib/types";
import NiceButton from "@/components/UI/NiceButton.vue";
import { doesControlHaveValueSetOrDoesControlSectionHaveDescendantsWithValue } from "@/lib/controls/values";
import OxyIndicatorLights from "@/oxygen/classes/OxyIndicatorLights.vue";
import OxygenCopyPastContextMenu from "@/oxygen/properties-panel/OxygenCopyPastContextMenu.vue";

@Component({
  components: {
    OxygenCopyPastContextMenu,
    OxyIndicatorLights,
    NiceButton,
    Icon
  }
})
export default class OxygenAccordionInput extends Vue {
  @Prop()
  control!: ControlAccordion;

  @ModelSync("value", "input")
  syncedValue?: Record<string, unknown>;

  @Prop()
  path!: string;

  open = false;
  showAll = false;

  @Watch("control", {
    immediate: true,
    deep: true
  })
  onControlChange() {
    this.open = this.control.open || false;
  }

  beforeCreate() {
    // @ts-ignore
    this.$options.components.OxygenControls =
      require("@/oxygen/classes/OxygenControls.vue").default;
  }

  get fullPath() {
    return `${this.path}`;
  }

  get filled() {
    return doesControlHaveValueSetOrDoesControlSectionHaveDescendantsWithValue(
      this.syncedValue
    );
  }

  get filteredControls() {
    const limit = this.control.hideAfter;

    if (limit && !this.showAll) {
      return this.control.controls?.slice(0, limit);
    }

    return this.control.controls;
  }
}
